var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "who-has-access" }, [
    _c("p", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.isEditing,
          expression: "!isEditing"
        }
      ],
      domProps: { innerHTML: _vm._s(_vm.label) }
    }),
    _vm._v(" "),
    _c("span", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isAdmin && !_vm.isEditing,
          expression: "isAdmin && !isEditing"
        }
      ],
      staticClass: "icon icon-rename",
      on: { click: _vm.openEditFullDiskEncryptionForm }
    }),
    _vm._v(" "),
    _vm.isEditing
      ? _c(
          "div",
          {
            directives: [
              {
                name: "click-outside",
                rawName: "v-click-outside",
                value: _vm.cancelEditFullDiskEncryptionForm,
                expression: "cancelEditFullDiskEncryptionForm"
              }
            ]
          },
          [
            _c("form", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.fullDiskEncryptionEnabled,
                    expression: "fullDiskEncryptionEnabled"
                  }
                ],
                staticClass: "checkbox",
                attrs: {
                  id: "fullDiskEncryptionEnabledCheckbox",
                  disabled: _vm.isSavingChanges,
                  type: "checkbox",
                  name: "fullDiskEncryptionEnabledCheckbox"
                },
                domProps: {
                  checked: Array.isArray(_vm.fullDiskEncryptionEnabled)
                    ? _vm._i(_vm.fullDiskEncryptionEnabled, null) > -1
                    : _vm.fullDiskEncryptionEnabled
                },
                on: {
                  change: [
                    function($event) {
                      var $$a = _vm.fullDiskEncryptionEnabled,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            (_vm.fullDiskEncryptionEnabled = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.fullDiskEncryptionEnabled = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.fullDiskEncryptionEnabled = $$c
                      }
                    },
                    _vm.saveFullDiskEncryptionForm
                  ]
                }
              }),
              _vm._v(" "),
              _c(
                "label",
                { attrs: { for: "fullDiskEncryptionEnabledCheckbox" } },
                [_vm._v("\n\t\t\t\t" + _vm._s(_vm.checkboxLabel) + "\n\t\t\t")]
              )
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }